import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import axios from "axios";
import { IoCloseCircle } from "react-icons/io5";

const CustomerPaymentTerm = ({ show, setShow, setError, setShowError, endpoint = "/v2/api/customer/paymentTerm", title = "Payment Terms and Conditions", termField = "paymentTerm" }) => {
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");
    const [paymentTerm, setPaymentTerm] = useState("");
    const [loading, setLoading] = useState(false);

    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { lanIndex, token, userId } = React.useContext(UserContext);

    useEffect(() => {
        setDisplay(show ? "flex" : "none");
        let active = true;
        if (token && show) {
            setPaymentTerm("");
            setLoading(true);
            axios.get(endpoint, {
                headers: { Authorization: "Bearer " + token },
            })
                .then(function (response) {
                    if (!active) return;
                    if (response.status == 200) {
                        setPaymentTerm(
                            (typeof response.data === "string" ? response.data : response.data[termField]) ||
                            response.data.html ||
                            response.data.pdpa ||
                            response.data.terms ||
                            response.data.term ||
                            response.data.content ||
                            ""
                        );
                    }
                })
                .catch(function () {
                    if (!active) return;
                    const errorMessage = "Something went wrong. Please try again";
                    if (setError && setShowError) {
                        setError([{ errorMessage }]);
                        setShowError(true);
                    } else {
                        setPaymentTerm(errorMessage);
                    }
                })
                .finally(() => { if (active) setLoading(false); });
        }
        return () => { active = false; };
    }, [show, token, userId, setError, setShowError, endpoint, termField]);

    return (
        <React.Fragment>
            <ModalContainer display={displayShow} role="dialog" aria-modal="true" aria-label={title}>
                <IconButton onClick={() => {
                    setShow(false);
                    setDisplay("none");
                }}>
                    <IoCloseCircle size={36} />
                </IconButton>
                <Title>
                    {title}
                </Title>
                <ContentWrapper>
                    <InputWrapper>
                        {loading ? <ModalContentText>Loading...</ModalContentText> : <ModalContentText
                            dangerouslySetInnerHTML={{ __html: paymentTerm }}
                        />}
                    </InputWrapper>
                    <ButtonWrapper>
                        <Button themeContext={themeContext} onClick={() => {
                            setShow(false);
                        }} >
                            {languageContext[lanIndex].ok}
                        </Button>
                    </ButtonWrapper>
                </ContentWrapper>
            </ModalContainer>
        </React.Fragment >
    );
}

export default CustomerPaymentTerm;

const ButtonWrapper = styled.div`
    display: flex;
`;

const Button = styled.div`
    display: flex;
    width: 120px;
    margin: 8px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    border-radius: 25px;
    line-height: 40px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.3);
`;

const InputWrapper = styled.pre`
    width: 100%;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;
`;

const IconButton = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  background: white;
  z-index: 99;
`;

const ModalContentText = styled.div`
    padding: 8px;
    white-space: pre-wrap;
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 500;
    margin-top: 24px;
    margin-left: 8px;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    overflow-y: auto;
    margin-top: 24px;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    position: fixed;
    flex-direction: column;
    background: #fff;
    top: 0;
    width: 100vw;
    max-width: 550px;
    height: 100dvh;
    z-index: 20;
    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
            transform: translateY(350px);
            opacity: 0;
        }
        100%  {
            transform: translateY(0px);
            opacity: 1;
        }
    }
`;
